module.exports = __webpack_public_path__ + "img/6.d9de0b59.png";